import PropTypes from "prop-types";
import * as constants from "@redbubble/design-system/react/constants";
import { userInfoPropType } from "../../containers/apollo/withUserInfo";

export const historyPropType = PropTypes.shape({
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
    state: PropTypes.object,
  }),
  replace: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
});

const profilePropType = PropTypes.oneOf([constants.MOBILE, constants.DESKTOP]);

const inventoryItemPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  price: PropTypes.shape({
    currency: PropTypes.string,
    amount: PropTypes.number,
  }),
});

const intlPropType = PropTypes.object;

const userAccountPropType = PropTypes.shape({
  analytics: PropTypes.string,
  displayName: PropTypes.string,
  hasAvatar: PropTypes.bool,
  isArtist: PropTypes.bool,
  joinedAt: PropTypes.string,
  metrics: PropTypes.string,
  onboardedAt: PropTypes.string,
  __typename: PropTypes.string,
});

export {
  userInfoPropType,
  profilePropType,
  intlPropType,
  inventoryItemPropType,
  userAccountPropType,
};
